import { createListModalComponent } from 'factories/ListModal'
import Filter from 'containers/OverstockInventory/SelectItemInventory/Filter'

export default createListModalComponent({
  getStorageKey: (self) => 'overstockInventory.listView.selectItemInventory',
  getSettingsType: (self) => 'itemInventory',
})(Filter)
